import styled from 'styled-components';

import { InputsWrapper } from '@common/components/forms';

export const DeliveryInputsWrapper = styled(InputsWrapper)`
  grid-row-gap: 2rem;
`;
